// formatV4Results.ts - Utility to format V4 results based on units
import { MatchItemV4 } from "../types/aiChatClientV4";
import { MatchItemV4Metric } from "../types/aiChatClientV4Metric";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { SearchResultSpaceInfo } from "../types/aiChatClient";

/**
 * Determines if an item uses metric units
 * @param item The item to check
 * @returns true if the item uses metric units, false otherwise
 */
export const isMetricUnit = (item: MatchItemV4): item is MatchItemV4Metric => {
  return "area_m2" in item;
};

/**
 * Formats space information based on units
 * @param item The item to format
 * @returns The formatted information
 */
export const formatSpaceInfo = (item: MatchItemV4): SearchResultSpaceInfo => {
  const isMetric = isMetricUnit(item);

  const spaceID = item.space_number;
  const tenant = item.tenant_name;
  const area = isMetric ? item.area_m2 : item.area_sf;
  const distance = isMetric ? item.distance_m : item.distance_ft;
  const totalRentPSF = isMetric ? item.rent_per_m2 : item.rent_per_sf;
  const leaseEndDate = item.lease_end_date || "";
  const totalRent = item.total_rent || "";
  const totalSales = item.sales_r12 || "";
  const mallName = (item as any).mall_name || (item as any).property_name;

  return {
    spaceID,
    tenant,
    area,
    distance,
    leaseEndDate,
    totalRent,
    totalRentPSF: totalRentPSF?.toString() || "",
    totalSales,
    totalSalesPSF: "",
    mall_name: mallName,
    property_name: (item as any).property_name,
  };
};

/**
 * Formats an array of match items
 * @param items Array of items to format
 * @returns Array of formatted space information
 */
export const formatSpaceInfoArray = (
  items: MatchItemV4[]
): SearchResultSpaceInfo[] => {
  return items.map((item) => formatSpaceInfo(item));
};
